module.exports = __webpack_public_path__ + "static/media/emilia.4313e2bb.svg";